import Svg, { Path } from 'react-native-svg';

import { useTheme } from '@/contexts/ThemeContext';
import { parseSignature } from '@/lib/signature';

/** Εμφανίζει μια αποθηκευμένη ζωγραφισμένη υπογραφή (JSON {d,w,h}). */
export function SignatureView({
  data,
  width = 160,
  color,
}: {
  data: string | null | undefined;
  width?: number;
  color?: string;
}) {
  const { colors } = useTheme();
  const strokeColor = color ?? colors.text;
  const sig = parseSignature(data);
  if (!sig) return null;
  const height = Math.round(width * (sig.h / sig.w));
  return (
    <Svg width={width} height={height} viewBox={`0 0 ${sig.w} ${sig.h}`}>
      <Path
        d={sig.d}
        stroke={strokeColor}
        strokeWidth={2.5}
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  );
}
